export default __webpack_public_path__ + "static/media/bg-gray-focus.ef5414f2.png";